import { FC, useMemo, useState } from 'react';
import { X } from 'lucide-react';

import { FileUploadDTO } from '@/types/api-types';

import { useFiltersUploadStore } from '@/stores/filtersUploadStore';

import { Badge } from '../ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const FilterBadges: FC = () => {
  const { filterByIds, clearFilterByIdsByValues } = useFiltersUploadStore();

  const [dialogOpen, setDialogOpen] = useState(false);

  const totalCount = useMemo(() => {
    return Object.values(filterByIds).flat().length;
  }, [filterByIds]);

  const renderLabels = (filter: keyof FileUploadDTO) => {
    switch (filter) {
      case 'name':
        return 'Назва';
      case 'status':
        return 'Статус';
      case 'created':
        return 'Дата створення';
      case 'modified':
        return 'Дата модифікації';
      case 'size':
        return 'Розмір';
      case 'file_type':
        return 'Тип';

      default:
        break;
    }
  };

  return totalCount > 0 ? (
    <div className="flex flex-wrap gap-2 p-2">
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <button
          type="button"
          className="rounded border border-separator bg-white px-2 py-1 text-sm text-primary hover:bg-neutral-50"
          aria-label={`Show all ${totalCount} filters`}
          onClick={() => setDialogOpen(true)}
        >
          Застосовані фільтри (+{totalCount})
        </button>
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>Застосовані фільтри ({totalCount})</DialogTitle>
          </DialogHeader>
          <div className="max-h-[60vh] overflow-auto">
            <div className="flex flex-wrap gap-2">
              {(Object.keys(filterByIds) as (keyof FileUploadDTO)[]).map(
                (key) =>
                  filterByIds[key]?.map((value) => (
                    <Badge
                      key={`${key}:${value}`}
                      variant="secondary"
                      className="h-6 gap-1 rounded border-separator bg-white px-1 py-1 text-sm font-normal text-primary"
                    >
                      <span>{`${renderLabels(key)}: ${value}`}</span>
                      <X
                        className="h-3 w-3 cursor-pointer"
                        onClick={() => clearFilterByIdsByValues(key, [value])}
                      />
                    </Badge>
                  )),
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  ) : null;
};

export default FilterBadges;
